<template>
  <div class="breadCrumb">
    <div><h3>Modifier Type de Consultation</h3></div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Configuration</li>
          <li class="breadcrumb-item">Types Consultations</li>
          <li class="breadcrumb-item active" aria-current="page">Modification</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="card p-3">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Nom</label>
        <input type="text" v-model="type.nom" class="form-control" :class="{ 'is-invalid': errors.nom }" />
        <div class="invalid-feedback">{{ errors.nom }}</div>
      </div>

      <div class="col-md-6 ">
        <label class="form-label">Prix</label>
        <input type="number" v-model="type.prix" class="form-control" :class="{ 'is-invalid': errors.prix }" />
        <div class="invalid-feedback">{{ errors.prix }}</div>
      </div>

      <div class="col-md-12 mb-3">
        <label class="form-label">Description</label>
        <textarea v-model="type.description" class="form-control" rows="3" ></textarea>
        
      </div>
     <div class="col-md-6">
  <div class="form-check form-switch mt-4">
    <input 
      class="form-check-input" 
      type="checkbox" 
      id="enabled" 
      v-model="type.isEnabled">
    <label class="form-check-label" for="enabled">Activé ?</label>
  </div>
</div>
    </div>

    <div class="d-flex justify-content-between">
      <button class="btn btn-danger" @click="cancel">Annuler</button>
      <button class="btn btn-success" @click="update">Mettre à jour</button>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      type: {
        id: null,
        nom: '',
        prix: 0,
        description: '',
        isEnabled: true
      },
      errors: {
        nom: '',
        prix: '',
        description: ''
      }
    };
  },
  methods: {
    async loadTypeConsultation() {
      try {
        const id = this.$route.params.id;
        const response = await api.getItem('type_consultations', id);
        this.type = response.data;
      } catch (error) {
        console.error("Erreur chargement type consultation:", error);
      }
    },
    validateForm() {
      this.errors = {
        nom: this.type.nom ? '' : 'Le nom est requis',
        prix: this.type.prix >= 0 ? '' : 'Le prix est requis',
      };
      return !Object.values(this.errors).some(msg => msg !== '');
    },
    async update() {
      if (!this.validateForm()) return;

      try {
        await api.updateItem('type_consultations', this.type.id, this.type);
        //alert("Type de consultation mis à jour !");
        this.$router.push({ name: 'type_consultation' }); 
      } catch (error) {
        console.error("Erreur lors de la mise à jour :", error);
      }
    },
    cancel() {
      this.$router.push({ name: 'type_consultation' });
    }
  },
  created() {
    this.loadTypeConsultation();
  }
};
</script>

<style scoped>
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
